export async function fetchStockData(url) {
    const response = await fetch('/stocktracker/api/scrape', {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: url
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
}

export async function fetchEnhancedMetrics(url) {
    // 1. Check localStorage first
    const cached = JSON.parse(localStorage.getItem('enhancedStocks') || '{}');
    if (cached[url] && isFresh(cached[url].lastUpdated)) {
        return cached[url];
    }

    // 2. Fetch from backend if no cache
    try {
        const response = await fetch(`/stocktracker/api/stock-metrics?url=${encodeURIComponent(url)}`);
        const data = await response.json();

        // 3. Update localStorage
        const newCache = { ...cached, [url]: data };
        localStorage.setItem('enhancedStocks', JSON.stringify(newCache));

        return data;
    } catch (error) {
        console.error('API fetch failed:', error);
        return cached[url] || null; // Fallback to stale cache if available
    }
}

// Helper function
function isFresh(timestamp) {
    return new Date(timestamp) > new Date(Date.now() - 24 * 60 * 60 * 1000); // 24h cache
}